/* global axios */
import ApiClient from '../ApiClient';

class ZernioChannel extends ApiClient {
  constructor() {
    super('zernio', { accountScoped: true });
  }

  generateAuthorization(payload) {
    return axios.post(`${this.url}/authorization`, payload);
  }

  getProfiles(credential) {
    return axios.get(`${this.url}/profiles`, { params: { credential } });
  }
}

export default new ZernioChannel();
